<template>
  <div style="min-height: 100px;" class="leftTree">
    <el-tree v-if="isBrowseRecordsSub" ref="ltree" :data="lookRecordTree" :props="defaultProps" @node-click="lookRecordTreeClick"
      @node-contextmenu="rightClick1">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>
          <img v-if="data.ICON" :src="isIcon(data.ICON)" alt class="imgicon" />
          {{ node.label }}
        </span>
      </span>
    </el-tree>
    <slot></slot>
    <el-tree class="templateTree jjjd" :highlight-current="true" default-expand-all :data="treeDataLeft"
      :default-checked-keys="list" :current-node-key="currentNodeKey" node-key="ID" ref="treeLeft" :render-after-expand="false"
      :props="defaultProps" draggable :allow-drop="allowDrop" :allow-drag="allowDrag" @node-drop="handleDrop2"
      @node-click="getAllTask" @node-contextmenu="rightClickLeft">
      <!--:class="{notAllowed:(notAllowed && data.TEMPTYPE != 1)}"-->
      <div :id="data.TEMPTYPE === 1? 'treeDraggable':''" slot-scope="{ node, data }" style="width: 100%;line-height: 40px;overflow: hidden;position: relative;"
        @mouseleave="mouseleave(data,$event)" @mouseover="mouseover(data,$event)" @mouseenter="mouseenter(data,$event)"
        @mousedown="mousedown(data,$event)" @dragenter="dragEnter(data, $event)" @dragend="dragEnd(data, $event)" @drop="drop(data, $event)"
        @dragleave="dragleave(data, $event)">
        <div class="subscript" v-if="data.TEMPTYPE === 1">
          结果集
        </div>
        <el-tooltip class="item" effect="dark" :value="data.ID==dragId" :hide-after="1000" content="不是结果集模板不可拖入"
          :manual="true" placement="top">
          <span class="custom-tree-node">

            <span>
              <img v-if="data.ICON" :src="isIcon(data.ICON)" alt class="imgicon" />
              {{ node.label }}
            </span>
          </span>
        </el-tooltip>
      </div>
    </el-tree>
    <div id="rClickLeft" v-show="rClickLeft">
      <rightClick @newClassClick="newClassClick" @newTemp="newTemp" @amendSeek="amendSeekLeft" @rcHuidiao="rcHuidiao"
        @getAllTask="getAllTask" :columns="columns" :treeObj="thisTreeObj" :treeNode="thisTreeNode" :isLeft="true"
        :ViewTypeState="ViewTypeState" :isViewType="isViewType" :isBlank="isBlank" ref="rightClick"></rightClick>
    </div>
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import draggable from "vuedraggable";
  import {
    UpdateTemplateOrderIndex,
    GetAllVisibleTemplateByUserId,
    UpdateTemplateOrder,
    UpdateTemplate
  } from "@/api/modules/basicData/task";
  import {
    listToTree
  } from "@/api/modules/basicData/commonData";
  // import searchJs from '@/util/search';
  import rightClick from "./contextmenu.vue";
  import {
    mapState
  } from "vuex";
  export default {
    data() {
      return {
        notAllowed: false,
        list: [],
        defaultProps: {
          children: "children",
          label: "label"
        },
        thisTreeObj: {},
        thisTreeNode: {},
        // lookRecordTree: [],
        // treeDataLeft: [],
        rClickLeft: false,
        isBrowseRecordsSub: this.isBrowseRecords,
        filedIDSub: this.filedID
      };
    },
    props: {
      columns: Array,
      isBlank: {
        type: Boolean,
        default: false
      },
      isViewType: {
        type: Boolean,
        default: false
      },
      ViewTypeState: {
        type: Array,
        default: function() {
          return [];
        }
      },
      isBrowseRecords: {
        //是否显示浏览记录
        type: Boolean,
        default: true
      },
      filedID: {
        type: String,
        default: "ID"
      },
      currentNodeKey: { //当前选中的值
        type: String,
        default: ""
      }
    },
    components: {
      rightClick,
      draggable
    },
    computed: {
      ...mapState({
        dragId: state => state.task.dragId,
      }),
      hhh: function() {
        return this.$store.state.task.hhh;
      },
      userId: function() {
        return this.$store.state.task.userId;
      },
      isLookRecord: function() {
        return this.$store.state.task.isLookRecord;
      },
      // category: function() {
      // 	return this.$store.state.task.category;
      // },
      lookRecordTree: function() {
        return this.$store.state.task.lookRecordTree;
      },
      treeDataLeft: function() {
        return this.$store.state.task.treeDataLeft;
      }
    },
    watch: {
      currentNodeKey(val) {
        this.$refs.treeLeft.setCurrentKey(val);
      }
    },
    mounted() {
      this.rowDrop();
    },
    methods: {
      getCurrentNodeKey(data) { //模板选中高亮显示
        this.$refs.treeLeft.setCurrentKey(data.ID);
      },
      drop(data, $event) {
        console.log('drop');
        let draggableRow = Object.assign({},
          this.$store.state.template.draggableRow
        );
        let row = Object.keys(this.$store.state.template.draggableRow);
        this.$store.state.template.draggableRow = {};

        // console.log('draggableRow',draggableRow)
        // console.log('字段值',draggableRow[this.filedID])
        if (row.length > 0) {
          if (data.TEMPTYPE == 1) {
            let arr = data.CONTENT.split(",");
            if (arr.indexOf(draggableRow[this.filedID]) == -1) {
              arr.push(draggableRow[this.filedID]);
              data.CONTENT = arr.join();
              UpdateTemplate(data, this.$store.state.task.category).then(res => {
                if (res == 1) {
                  this.$message({
                    type: "success",
                    message: "保存成功"
                  });
                }
              });
            } else {
              this.$message({
                type: "info",
                message: "已经包含此数据"
              });
            }
          } else {
            this.$message({
              type: "info",
              message: "不是结果集模板不能进行添加"
            });
          }
        }

        this.$store.commit('setDragId', '');

      },
      dragleave(data, $event) {
        console.log('dragleave');
        // $event.currentTarget.className="custom-tree-node";
      },
      dragEnter(data, $event) {
        // this.notAllowed=true;
        if (data.TEMPTYPE != 1)
          this.$store.commit('setDragId', data.ID);
        else
          this.$store.commit('setDragId', '');
        // this.treeDataLeft.forEach(item=>{
        //     if(data.ID===item.ID){
        //       item.isTooltip=true;
        //     }else{
        //       item.isTooltip=false;
        //     }
        // });
        // $event.currentTarget.className="custom-tree-node notAllowed";
        // $event.preventDefault();
        console.log('dragEnter');
      },

      mousedown(data, $event) {
        // console.log('mousedown');
      },
      dragEnd(data, $event) {
        // console.log('dragEnd');
      },
      mouseenter(data, $event) {
        // console.log('lookRecordTree:',this.lookRecordTree);
        // this.$store.state.template.draggableRow = {};
      },
      mouseleave(data, $event) {
        // console.log('mouseleave');
        this.$store.state.template.draggableRow = {};
      },
      mouseover(data, $event) {
        // console.log('mouseover');
      },
      newClassClick() {
        this.$emit("newClassClick");
      },
      newTemp() {
        this.$emit("newTemp");
      },
      rcHuidiao() {
        this.$emit("getAllClass");
      },
      amendSeekLeft(data) {
        this.$emit("leftSearch", data);
      },
      isIcon(val) {
        if (val) {
          return require("@/assets/icon/" + val);
        }
      },
      lookRecordTreeClick(data) {
        this.rClickLeft = false;
        console.log("ref-ltree-1--->", this.$refs.ltree);
        this.$emit("getAllTask", data);
      },
      getAllTask(data) {
        console.log("leftTree节点点击:", data);
        this.$refs.rightClick.Hide();
        this.rClickLeft = false;
        this.$emit("getAllTask", data);
      },
      rightClickLeft(ev, data, node, val) {
        //右击
        let dom = document.getElementById("rClickLeft");
        let pageHeight = ev.pageY;
        // console.log("top", ev.pageY);
        // console.log("高度", $(window).height());
        console.log("右键菜单高度", dom.clientHeight || dom.offsetHeight);
        if (pageHeight + 218 > $(window).height()) {
          pageHeight = $(window).height() - 220;
        }
        this.rClickLeft = true;
        dom.style.top = pageHeight + "px";
        dom.style.left = ev.pageX + "px";
        // dom.style.display = 'block';
        this.thisTreeObj = data;
        this.thisTreeNode = node;

        const postition = {
          top: pageHeight,
          left: ev.pageX
        };
        this.$refs.rightClick.Show(postition);
      },
      rightClick1() {}, //不可删
      handleDrop2(draggingNode, dropNode, dropType, ev) {
        //拖拽结束调用
        let pid = null;
        console.log(this.treeDataLeft, "treeDataLeft");
        if (draggingNode.data.TEMPTYPE !== 2) {
          if (dropNode.data.PID) {
            pid = dropNode.data.PID;
          } else {
            pid = dropNode.data.ID;
          }
        }

        let arr = dropNode.parent.childNodes;
        let temObj = draggingNode.data;
        let temIndex = null;
        for (let [index, val] of arr.entries()) {
          if (temObj.ID == val.data.ID) {
            temIndex = index;
          }
        }
        var formData = new FormData();

        let arrRet = this.translateTreeData(this.treeDataLeft);
        UpdateTemplateOrder(arrRet, this.userId).then(res => {});
      },
      translateTreeData(treeData) {
        let arrRet = [];
        this.func1(treeData, arrRet);
        return arrRet;
      },
      func1(treeData, arr, pid) {
        if (!treeData || treeData.length == 0) return;
        for (let i = 0; i < treeData.length; i++) {
          treeData[i].PID = pid;
          arr.push(treeData[i]);
          let treeData1 = treeData[i].children;
          this.func1(treeData1, arr, treeData[i].ID);
        }
      },
      allowDrop(draggingNode, dropNode, type) {
        console.log("目标节点", type);
        //设置拖拽规则
        // console.log('draggingNode:',draggingNode);
        // console.log('dropNode:',dropNode);
        if (draggingNode.data.PID && dropNode.data.PID) {
          // 拖拽的不是父节点，目标位置也不是父节点，不放在节点内部
          // if (
          //   draggingNode.data.ROLETYPE == 2 &&
          //   dropNode.parent.data.TEMPTYPE !== 4
          // ) {
          //   //拖拽的系统模板，目标位置不是系统分组，返回false
          //   return true;
          // } else {
          return type !== "inner";
          // }
        } else if (!draggingNode.data.PID && !dropNode.data.PID) {
          return type !== "inner"; //  拖拽的是父节点，目标位置也是父节点，不放在内部
        } else if (!draggingNode.data.PID && dropNode.data.PID) {
          return false; // 拖拽的是父节点，目标位置不是父节点
        } else if (draggingNode.data.PID && !dropNode.data.PID) {
          // 拖拽的不是父节点，目标位置是父节点，放在节点内部
          // if (draggingNode.data.ROLETYPE == 2 && dropNode.data.TEMPTYPE !== 4) {
          //   return true;
          // } else {
          return type == "inner";
          // }
        } else {
          return true;
        }
      },
      allowDrag(draggingNode) {
        //设置不可拖拽节点
        //if (draggingNode.data.ROLETYPE === 2 && this.userId !== "super") {
        // console.log('draggingNode.data',draggingNode.data.TEMPTYPE);
        // if (draggingNode.data.TEMPTYPE === 1) {
        //   return false;
        // } else {
        return true;
        // }
      },
      //行拖拽
      rowDrop() {
        // setTimeout(() => {
        //   const tbody = document.getElementById("treeDraggable");
        //   Sortable.create(tbody, {
        //     sort: false,
        //     group: "shared"
        //   });
        // }, 1000);
      }
    }
  };
</script>

<style lang="less" scoped>
  .subscript {
    color: #fff;
    height: 30px;
    width: 80px;
    position: absolute;
    right: -25px;
    top: -10px;
    text-align: center;
    line-height: 40px;
    font-size: 5px;
    background-color: #23AD9E;
    -moz-transform: rotate(30deg);
    -webkit-transform: rotate(30deg);
    -o-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg);
  }

  .imgicon {
    width: 18px;
    height: 18px;
    margin-right: 12px;
    vertical-align: middle;
  }

  .templateTree.jjjd {
    /deep/.el-tree-node {
      /deep/ .is-current {
        /deep/ .el-tree-node__content {
          background-color: #23AD9E;
          color: white;
        }
      }
    }

    // /deep/.el-tree--highlight-current{
    //   /deep/.el-tree-node{
    //     /deep/ .is-current {
    //       /deep/ .el-tree-node__content {
    //         background-color: #19acf9 !important;
    //         color: white;
    //       }
    //     }
    //   }
    // }

    // /deep/ .el-tree-node:focus>.el-tree-node__content {
    //   background-color: #19acf9 !important;
    //   color: white;
    // }
    // /deep/ .el-tree--highlight-current
    //   {/deep/.el-tree-node /deep/.is-current /deep/ .el-tree-node__content {
    //     background-color: #19acf9 !important;
    //     color: white;
    //   }
    // }
  }

  #rClickLeft {
    position: fixed;
    top: 100px;
    left: 0;
    z-index: 99;
  }

  .leftTree /deep/ .el-tree {
    font-family: 'Microsoft YaHei';
    background-color: #EEF2F5;
    color: rgb(51, 51, 51);
    letter-spacing: 0.6px;
    font-size: 16px;
  }

  /deep/ .custom-tree-node {
    width: 100%;
    display: block;
  }

  // .el-tree-node:focus {
  //   background-color: rgb(25,172,249);
  //   color:#fff;
  // }

  .notAllowed {
    cursor: not-allowed;
    border: 2px dashed #eee;
  }
</style>
